const TRACKED_PARAMS = ['q', 'tabId'];

export default class SensorsController {
    /** @ngInject */
    constructor(EventEmitter, $state, $stateParams, $location) {
        this.EventEmitter = EventEmitter;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$location = $location;
    }

    $onInit() {
        TRACKED_PARAMS.forEach((paramName) => {
            this[paramName] = this.$stateParams[paramName];
        });
    }

    uiOnParamsChanged(params) {
        TRACKED_PARAMS.forEach((paramName) => {
            if (paramName in params) {
                this[paramName] = params[paramName];
            }
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/sensors.controller.js